import { render, staticRenderFns } from "./UserUploads.vue?vue&type=template&id=2086d29b&"
import script from "./UserUploads.vue?vue&type=script&lang=js&"
export * from "./UserUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports